"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TypeScriptUtility_1 = require("./common/TypeScriptUtility");
/**
 * Smart constructor for creating a left value.
 *
 * @param value - The left value.
 */
function left(value) {
    return {
        type: 'Left',
        value: value
    };
}
exports.left = left;
/**
 * Smart constructor for creating a right value.
 *
 * @param value - The right value.
 */
function right(value) {
    return {
        type: 'Right',
        value: value
    };
}
exports.right = right;
/**
 * Higher-order helper function for either values.
 *
 * @param f - Function to apply to a left value.
 * @param g - Function to apply to a right value.
 */
function either(f, g) {
    return function (e) {
        switch (e.type) {
            case 'Left': return f(e.value);
            case 'Right': return g(e.value);
            default: return TypeScriptUtility_1.assertNever(e);
        }
    };
}
exports.either = either;
/**
 * Returns a left value or a given default if applied to a right value.
 *
 * @param l - Default value.
 */
function fromLeft(l) {
    return either(function (v) { return v; }, function (_) { return l; });
}
exports.fromLeft = fromLeft;
/**
 * Returns a right value or a given default if applied to a left value.
 *
 * @param r - Default value.
 */
function fromRight(r) {
    return either(function (_) { return r; }, function (v) { return v; });
}
exports.fromRight = fromRight;
/**
 * Checks if a given either value is left.
 *
 * @param e - The either value to check.
 */
function isLeft(e) {
    return either(function (_) { return true; }, function (_) { return false; })(e);
}
exports.isLeft = isLeft;
/**
 * Checks if a given either value is right.
 *
 * @param e - The either value to check.
 */
function isRight(e) {
    return !isLeft(e);
}
exports.isRight = isRight;
//# sourceMappingURL=Either.js.map